import React from 'react';

export default function BlueEnvelopeProgramOverview() {
  return (
    <div className="max-w-4xl mx-auto bg-white p-8">
      <p className="font-bold text-base mb-4">
        Blue Envelope Program – Information Overview
      </p>

      <p className="mb-2">Purpose</p>

      <p className="mb-4">
        The Blue Envelope Program is a voluntary communication support initiative designed to reduce confusion and stress during vehicle stops and similar high-stress interactions.
      </p>

      <p className="mb-4">
        The program provides a simple, recognizable way for drivers to share information that may help support clearer communication during stressful situations.
      </p>

      <p className="mb-6">
        The Blue Envelope Program is informational in nature and does not replace standard procedures or decision-making.
      </p>

      <p className="mb-2">What the Blue Envelope Communicates</p>

      <p className="mb-2">
        A Blue Envelope is intended to signal that the driver may benefit from additional time and clear communication during an interaction.
      </p>

      <p className="mb-2">It may indicate that the driver:</p>

      <p className="mb-1">Experiences anxiety in stressful or unfamiliar situations</p>

      <p className="mb-1">Is sensitive to bright lights, loud sounds, or rapid verbal instructions</p>

      <p className="mb-1">May need additional time to process and respond</p>

      <p className="mb-1">May communicate differently under stress</p>

      <p className="mb-6">
        The Blue Envelope does not indicate a specific diagnosis and does not imply incapacity.
      </p>

      <p className="mb-2">Program Participation</p>

      <p className="mb-2">
        Participation in the Blue Envelope Program is voluntary. Drivers choose whether and when to present the envelope.
      </p>

      <p className="mb-2">Drivers may choose not to present the envelope at any time.</p>

      <p className="mb-6">
        The presence of a Blue Envelope does not grant special privileges and does not alter standard procedures.
      </p>

      <p className="mb-2">What the Program Is Not</p>

      <p className="mb-2">The Blue Envelope Program:</p>

      <p className="mb-1">Is not a form of identification</p>

      <p className="mb-1">Is not a license or permit</p>

      <p className="mb-1">Does not replace standard procedures</p>

      <p className="mb-6">Does not limit discretion or authority</p>

      <p className="mb-2">Additional Information</p>

      <p className="mb-4">Additional information is provided within the Blue Envelope materials.</p>
    </div>
  );
}